import React, { useEffect, useState } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import axios from "axios";
import { api, post, put } from "../../../../../utils/api";
import InputField from "../../../../../Components/Masters/InputField";
import RadioField from "../../../../../Components/Masters/RadioField";
import FileField from "../../../../../Components/Masters/FileField";
import SelectField from "../../../../../Components/Masters/SelectField";
import { validateNumber } from "../../../../../utils/validateFields";
import { numberError } from "../../../../../utils/validationMessage";
import EditDialog from "../../../../../Components/Common/EditDialog";
import { formatTimestamp } from "../../../../../utils/formatTimeStamp";
import DateField from "../../../../../Components/Masters/DateField";

function AddVehicle({
  inputData,
  fetchData,
  id,
  data,
  element,
  setAddData,
  addData,
  setsnackOpen,
  addUrl,
  updateUrl,
}) {
  const [errors, setErrors] = useState({});
  const [upload, setUpload] = useState("yes");
  const [transportType, setTransportType] = useState("");
  const [formData2, setFormData2] = useState();
  const [editDialog, setEditDialog] = useState(false);
  const [upload2, setUpload2] = useState("yes");

  // Dynamically build initial state based on inputData
  const initialState = {
    transportType: element?.transportType || "", // Fallback to empty string if undefined
    ownership: element?.ownership || "", // Fallback to empty string if undefined
    vehicleNumber: element?.vehicleNumber || "", // Fallback to empty string if undefined
    vehicleCategory: element?.vehicleCategory || "", // Fallback to empty string if undefined
    vehicleType: element?.vehicleType || "", // Fallback to empty string if undefined
    brand: element?.brand || "", // Fallback to empty string if undefined
    model: element?.model || "", // Fallback to empty string if undefined
    purchaseDate: element?.purchaseDate || "", // Fallback to empty string if undefined
    lastServiceDate: element?.lastServiceDate || "", // Fallback to empty string if undefined
    fuelType: element?.fuelType || "", // Fallback to empty string if undefined
    declaredEfficiency: {
      value: element?.declaredEfficiency?.value || "", // Fallback to empty string if undefined
      unit: element?.declaredEfficiency?.unit || "", // Fallback to empty string if undefined
    },
    bharatStageEmissionType: element?.bharatStageEmissionType || "", // Fallback to empty string if undefined
    loadCapacity: element?.loadCapacity || "", // Fallback to empty string if undefined
    passengerCapacity: element?.passengerCapacity || "", // Fallback to empty string if undefined
    uploadDocuments: element?.uploadDocuments || "yes", // Defaulting to "yes" if undefined
    pucDocs: element?.pucDocs || [], // Fallback to empty array if undefined
    pollutionDocs: element?.pollutionDocs || [], // Fallback to empty array if undefined
    rcDocs: element?.rcDocs || [], // Fallback to empty array if undefined
    insuranceDocs: element?.insuranceDocs || [], // Fallback to empty array if undefined
    logisticsVendor: element?.logisticVendor?._id || "", // Fallback to empty string if undefined
  };

  console.log("eleme", element);

  const [uploadProgress, setUploadProgress] = useState({}); // Holds progress for each file
  const [formData, setFormData] = useState(initialState);
  const [uploadedFiles, setUploadedFiles] = useState({
    pucDocs: [],
    pollutionDocs: [],
    rcDocs: [],
    insuranceDocs: [],
  });

  const [docError, setDocError] = useState({
    pucDocs: [],
    pollutionDocs: [],
    rcDocs: [],
    insuranceDocs: [],
  });

  useEffect(() => {
    console.log(element, "element");
    resetForm();
  }, [element, id]);

  const unitOptions = {
    "Diesel (average biofuel blend)": ["Km/Liter"], // Example units for Diesel
    "Diesel (100% mineral diesel)": ["Km/Liter"],
    "Petrol (average biofuel blend)": ["Km/Liter"],
    "Petrol (100% mineral petrol)": ["Km/Liter"],
    CNG: ["Km/Kg"], // Example for CNG
    Electricity: ["Km/Kwh"], // Example for Electricity
  };

  const handleChange = (e) => {
    const { name, value } = e.target; // Correctly extract name and value from e.target
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: undefined, // Remove error for the specific field
    }));
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name.startsWith("declaredEfficiency.")) {
      const [field, key] = name.split(".");
      console.log(field, key);

      setFormData((prevState) => ({
        ...prevState,
        [field]: {
          ...prevState[field],
          [key]: value,
        },
      }));

      setErrors((prevState) => ({
        ...prevState,
        [field]: {
          ...prevState[field],
          [key]: "",
        },
      }));
    } else {
      if (name === "vehicleNumber") {
        const regex = new RegExp(`^${value}$`, "i"); // 'i' flag makes it case-insensitive
        const vehicle = data.filter((el) => regex.test(el.vehicleNumber));

        // Check if the GST Number already exists and the IDs don't match (or if no GST record exists, skip the validation)
        if (
          vehicle.length > 0 &&
          (element ? element?._id !== vehicle[0]?._id : true)
        ) {
          setErrors({
            ...errors,
            [name]: "Vehicle Number already exists.",
          });
        }

        return;
      }

      // Handling specific conditions based on field names
      if (name === "transportType") {
        setTransportType(value);
        if (value === "Passenger") {
          setFormData((prev) => ({
            ...prev,
            loadCapacity: "",
            vehicleCategory: "",
          }));
        } else if (value === "Freight") {
          setFormData((prev) => ({
            ...prev,
            passengerCapacity: "",
            ownership: "Leased",
            // logisticsVendor:prev.logisticsVendor ||  "",
          }));
        }
      }

      // Handling specific conditions based on field names
      if (name === "ownership") {
        // If ownership is set to "Leased", show the logisticsVendor field
        if (value !== "Leased") {
          setFormData((prev) => ({
            ...prev,
            logisticsVendor: "", // Make sure logisticsVendor is set if it's not already
          }));
        }
      }

      if (name === "fuelType") {
        setFormData((prevState) => ({
          ...prevState,
          declaredEfficiency: {
            ...prevState.declaredEfficiency,
            unit: unitOptions[value]?.[0],
          },
        }));

        setErrors((prevState) => ({
          ...prevState,
          declaredEfficiency: {
            ...prevState.declaredEfficiency,
            unit: "",
          },
        }));
      }
    }
  };

  const handleDateChange = (e) => {
    const { name, value } = e; // Correctly extract name and value from e.target

    console.log(`Input changed: ${name}, Value: ${value}`);

    if (name === "purchaseDate" && formData.lastServiceDate < value)
      setFormData({ ...formData, lastServiceDate: "" });

    // Clear the specific error for the field being changed
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: undefined, // Remove error for the specific field
    }));

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFileChange = async (e) => {
    const { name, files } = e.target;
    // Clear previous errors
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: [], // Initialize as an empty array to accumulate errors
    }));
    // Clear document errors
    setDocError((prevErrors) => ({
      ...prevErrors,
      [name]: [], // Initialize as an empty array to accumulate errors
    }));

    if (!files || files.length === 0) return;

    const newErrors = [];
    const uploadFiles = []; // Store the uploaded files
    const progressTracker = Array(files.length).fill(0); // Initialize an array for tracking progress
    const currentUploadedFiles = formData[name] || []; // Existing uploaded files

    console.log(
      "current",
      name,
      currentUploadedFiles,
      uploadedFiles[name],
      files,
    );
    const excludedTypes = [
      "application/zip", // .zip files
      "application/x-rar-compressed", // .rar files
      "application/x-tar", // .tar files
      "application/gzip", // .gz files
      "application/x-7z-compressed",
      ".zip", // .7z files
    ];

    const excludedExtensions = [
      ".zip", // .zip files
      ".rar", // .rar files
      ".tar", // .tar files
      ".gz", // .gz files
      ".7z", // .7z files
    ];

    const maxFileSize = 5 * 1024 * 1024; // 5 MB

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      // Check if the total count exceeds the limit
      if (
        currentUploadedFiles?.length +
          files?.length +
          uploadedFiles[name]?.length >
        5
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: ["You cannot upload more than 5 files."],
        }));
        return; // Exit the loop if limit is reached
      }
      const fileExtension = file.name.toLowerCase().split(".").pop();
      // Check file type
      if (
        excludedTypes.includes(file.type) ||
        excludedExtensions.includes(`.${fileExtension}`)
      ) {
        newErrors.push(`File type not allowed: ${file.name}`);
        continue;
      }

      // Check file size
      if (file.size > maxFileSize) {
        newErrors.push(`File size exceeds 5MB: ${file.name}`);
        continue; // Continue checking the next file
      }

      // Create a FormData object
      const timestamp = Date.now();
      const originalFileName = file.name.split(".").slice(0, -1).join("."); // Remove extension from original filename
      const formattedTimestamp = formatTimestamp(timestamp);
      const uniqueFileName = `${originalFileName}_${formattedTimestamp}.${fileExtension}`; // Combine the original name and timestamp

      // Create a new File object with the unique name
      const uniqueFile = new File([file], uniqueFileName, { type: file.type });

      const formData = new FormData();
      formData.append("files", uniqueFile); // Set the unique file name

      try {
        // Upload the file
        const res = await axios.post(`${api}/cloud/upload`, formData, {
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            );
            progressTracker[i] = percent;

            // Update progress bar dynamically
            const overallProgress = Math.round(
              progressTracker.reduce((sum, p) => sum + p, 0) / files.length,
            );
            setUploadProgress((prev) => ({ ...prev, [name]: overallProgress }));
          },
        });

        // Append newly uploaded file URLs
        uploadFiles.push(...res.data.urls); // Use spread operator to add URLs
      } catch (error) {
        newErrors.push(`Failed to upload ${file.name}. Please try again.`);
      }
    }

    // Update uploaded files state only if there are valid uploads
    if (uploadFiles.length > 0) {
      setUploadedFiles((prev) => ({
        ...prev,
        [name]: [...prev[name], ...uploadFiles],
      }));
    }

    console.log(uploadedFiles);

    setUploadProgress((prev) => ({ ...prev, [name]: 0 })); // Reset progress after upload

    // Update errors if any
    if (newErrors.length > 0) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: newErrors, // Store all accumulated errors for this field
      }));
    }
    e.target.value = null;
  };

  const handleDeleteFile = (fieldName, fileUrl) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: [], // Initialize as an empty array to accumulate errors
    }));
    // Clear document errors
    setDocError((prevErrors) => ({
      ...prevErrors,
      [fieldName]: [], // Initialize as an empty array to accumulate errors
    }));
    setUploadedFiles((prevUploadedFiles) => ({
      ...prevUploadedFiles,
      [fieldName]: prevUploadedFiles[fieldName].filter(
        (file) => file !== fileUrl,
      ),
    }));
  };

  const handleExitAgree = () => {
    setEditDialog(false);
    setAddData(false);
    setErrors({});
    setDocError({});
    resetForm();
  };

  const handleClose = () => {
    console.log(formData, formData2);
    const isFormDataUnchanged = Object.keys(formData).every(
      (key) => formData[key] === formData2[key],
    );
    const isFilesUnchanged = Object.keys(uploadedFiles).every((key) => {
      return (
        JSON.stringify(uploadedFiles[key]) ===
        JSON.stringify(formData2?.[key] || [])
      );
    });
    if (isFormDataUnchanged && isFilesUnchanged && upload === upload2) {
      handleExitAgree();
    } else {
      setEditDialog(true); // Show the EditDialog if there are changes
    }
  };

  const resetForm = () => {
    setFormData(initialState);
    setFormData2(initialState);
    setUploadedFiles({
      pucDocs: element?.pucDocs || [],
      pollutionDocs: element?.pollutionDocs || [],
      rcDocs: element?.rcDocs || [],
      insuranceDocs: element?.insuranceDocs || [],
    });
    if (id && element) {
      const isUploaded =
        element?.pucDocs?.length > 0 &&
        element?.pollutionDocs?.length > 0 &&
        element?.rcDocs?.length > 0 &&
        element?.insuranceDocs?.length > 0
          ? "yes"
          : "no";
      setUpload(isUploaded);
      setUpload2(isUploaded);
    } else {
      setUpload("yes");
      setUpload2("yes");
    }
  };

  const handleRadioChange = (e) => {
    setUpload(e.target.value);
    if (e.target.value === "no")
      setErrors({
        ...errors,
        pucDocs: "",
        insuranceDocs: "",
        pollutionDocs: "",
        rcDocs: "",
      });
  };

  const validateForm = () => {
    const newErrors = {}; // Create a copy of the current errors to preserve previous ones
    inputData.forEach((input) => {
      const value = formData[input.fieldName];
      console.log(input.fieldName);
      // Skip validation for upload documents fields if not required
      if (input.fieldName.endsWith("Docs")) {
        console.log(upload);
        // Check if files have been uploaded for this field
        if (upload === "no") return;
        if (upload === "yes") {
          if (
            !uploadedFiles[input.fieldName] ||
            uploadedFiles[input.fieldName].length === 0
          ) {
            newErrors[input.fieldName] = `Please upload ${input.title} `;
          }
        }
        return; // Skip other validations for this input
      }

      // Skip ownership validation if transportType is Freight
      if (
        formData.transportType === "Freight" &&
        input.fieldName === "ownership"
      ) {
        return; // Skip this validation
      }

      // Check for lastServiceDate not being earlier than purchaseDate
      if (input.fieldName === "lastServiceDate" && formData.purchaseDate) {
        const purchaseDate = new Date(formData.purchaseDate);
        const lastServiceDate = new Date(value);

        if (lastServiceDate < purchaseDate) {
          newErrors.lastServiceDate =
            "Last service date cannot be earlier than purchase date.";
        }
      }
      // Handle transport type specific validations
      if (
        formData.transportType === "Passenger" &&
        (input.fieldName === "loadCapacity" ||
          input.fieldName === "vehicleCategory")
      ) {
        return;
      }
      if (
        formData.transportType === "Freight" &&
        input.fieldName === "passengerCapacity"
      ) {
        return;
      }
      if (
        formData.ownership === "Company owned" &&
        input.fieldName === "logisticsVendor"
      ) {
        return;
      }

      // Check for empty strings for fields that should be filled
      if (typeof value === "string" && (!value || value.trim() === "")) {
        newErrors[input.fieldName] = `${input.title} is required.`;
        return; // Skip other validations for this input
      }

      if (input.fieldName === "declaredEfficiency") {
        const cvValue = formData?.declaredEfficiency?.value || ""; // Ensure it's a string
        const cvUnit = formData?.declaredEfficiency?.unit || ""; // Ensure it's a string
        console.log(cvUnit, formData.declaredEfficiency);
        if (!validateNumber(cvValue)) {
          newErrors[input.fieldName] = {
            ...newErrors[input.fieldName],
            value: "Numeric value is required.",
          };
        }

        if (!cvUnit.trim()) {
          newErrors[input.fieldName] = {
            ...newErrors[input.fieldName],
            unit: "Unit is required.",
          };
        }
        return; // Ensure to return after handling errors for calorificValue
      }
      // Additional validations based on transport type
      if (formData.transportType === "Passenger") {
        if (input.fieldName === "ownership" && !formData.ownership) {
          newErrors.ownership = "Ownership is required.";
        }
        if (
          input.fieldName === "passengerCapacity" &&
          !validateNumber(formData.passengerCapacity)
        ) {
          newErrors.passengerCapacity = numberError;
        }
        if (
          input.fieldName === "logisticsVendor" &&
          // formData.ownership === "Leased" &&
          !formData.logisticsVendor
        ) {
          newErrors.logisticsVendor = "Logistics vendor is required.";
        }
      } else if (formData.transportType === "Freight") {
        if (input.fieldName === "loadCapacity" && !formData.loadCapacity) {
          newErrors.loadCapacity = "Load capacity is required";
        }

        if (
          input.fieldName === "loadCapacity" &&
          !validateNumber(formData.loadCapacity)
        ) {
          newErrors.loadCapacity = numberError;
        }
      }

      if (input.fieldName === "vehicleNumber") {
        const regex = new RegExp(`^${value}$`, "i"); // 'i' flag makes it case-insensitive
        const vehicle = data.filter((el) => regex.test(el.vehicleNumber));

        // Check if the GST Number already exists and the IDs don't match (or if no GST record exists, skip the validation)
        if (
          vehicle.length > 0 &&
          (element ? element?._id !== vehicle[0]?._id : true)
        ) {
          newErrors.vehicleNumber = "Vehicle Number already exists";
        }
      }
    });
    console.log(newErrors); // Log newErrors to see current validation results
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const filterFormData = (data) => {
    const filteredData = { ...data, ...uploadedFiles };

    console.log(filteredData);

    // Remove unnecessary fields based on conditions
    if (data.transportType === "Passenger") {
      delete filteredData.loadCapacity; // Don't send loadCapacity
      delete filteredData.vehicleCategory;
    }

    if (data.transportType === "Freight") {
      delete filteredData.passengerCapacity; // Don't send passengerCapacity
    }

    if (data.ownership === "Company owned") {
      delete filteredData.logisticsVendor;
    }

    // Optionally remove uploadDocuments if not necessary
    if (upload === "no") {
      Object.keys(filteredData).forEach((key) => {
        if (key.endsWith("Docs")) {
          delete filteredData[key]; // Don't send document fields
        }
      });
    }

    return filteredData;
  };

  const Save = async () => {
    if (!validateForm()) return;

    const dataToSend = filterFormData(formData);
    setErrors({});
    setDocError({});

    try {
      const url = id ? updateUrl : addUrl;
      const response = id
        ? await put(`${url}?id=${id}`, { ...dataToSend })
        : await post(url, dataToSend);

      fetchData();
      setsnackOpen({
        open: true,
        message: response.data.message,
        severity: "success",
      });

      setUploadedFiles({
        pucDocs: [],
        pollutionDocs: [],
        rcDocs: [],
        insuranceDocs: [],
      });
      setUpload("yes");
      handleExitAgree();
    } catch (err) {
      const errorMessage = err?.response?.data?.message || "An error occurred";
      setsnackOpen({
        open: true,
        message: errorMessage,
        severity: "error",
      });
    }
  };

  const renderInputField = (el) => {
    if (el.fieldName === "declaredEfficiency") {
      return (
        <Box display="flex" gap={1} sx={{ width: "100%" }}>
          <Box sx={{ width: "60%" }}>
            <InputField
              title={el.title}
              handleChange={handleChange}
              placeholder={el.placeholder}
              value={formData[el.fieldName]?.value || ""}
              errors={errors[el.fieldName]?.value} // Access error for value
              fieldName={`${el.fieldName}.value`}
            />
          </Box>
          <Box sx={{ width: "40%", mt: "9%" }}>
            <InputField
              name={`${el.fieldName}.unit`}
              value={formData.declaredEfficiency?.unit}
              // handleChange={handleChange}
              placeholder={"Unit"}
              options={unitOptions[formData.fuelType] || []}
              errors={errors[el.fieldName]?.unit} // Access error for unit
              field={`${el.field}.unit`}
              disabled={true}
              defaultValue="Select Unit"
            />
          </Box>
        </Box>
      );
    }

    if (el.fieldName === "uploadDocuments") {
      return (
        <RadioField
          handleChange={handleRadioChange}
          title={el.title}
          formData={formData}
          value={upload}
          fieldName={el.fieldName}
          errors={errors}
        />
      );
    }

    if (el.fieldName === "vehicleType") {
      return (
        <SelectField
          title={el.title}
          name={el.fieldName}
          value={formData[el.fieldName]}
          handleChange={handleChange}
          disable={
            formData.vehicleCategory === "" &&
            (formData.transportType === "" ||
              formData.transportType !== "Passenger")
          }
          options={
            formData.vehicleCategory
              ? (formData.vehicleCategory ===
                  "Heavy Commercial Vehicles (HCV)" && [
                  "Heavy Duty Trucks",
                  "Tanker Trucks",
                  "Refrigerated trucks",
                ]) ||
                (formData.vehicleCategory ===
                  "Medium Commerical Vehicles (MCV)" && [
                  "Medium Duty trucks",
                  "Flatbed trucks",
                ]) ||
                (formData.vehicleCategory ===
                  "Light Commerical Vehicles (LCV)" && ["Light duty trucks"])
              : formData.transportType === "Passenger" && [
                  "Sedan",
                  "SUV",
                  "Hatchback",
                  "Motorcycle / Scooter",
                  "Bus - Heavy",
                  "Bus - Medium ",
                ]
          }
          errors={errors[el.fieldName]}
          url={el.url}
          field={el.field || ""}
        />
      );
    }
    if (el.type === "select") {
      return (
        <SelectField
          title={el.title}
          name={el.fieldName}
          value={formData[el.fieldName]}
          handleChange={handleChange}
          options={el.options}
          errors={errors[el.fieldName]}
          url={el.url}
          field={el.field || ""}
        />
      );
    }

    if (el.type === "date") {
      return (
        // <DateField
        //   title={el.title}
        //   name={el.fieldName}
        //   lastServiceDate={formData.lastServiceDate}
        //   purchaseDate={formData.purchaseDate}
        //   disable={
        //     el.fieldName === "lastServiceDate" && formData.purchaseDate === ""
        //   }
        //   value={formData[el.fieldName]}
        //   handleChange={handleDateChange}
        //   errors={errors[el.fieldName]}
        // />
        <DateField
          title={el.title}
          handleChange={handleDateChange}
          disable={
            el.fieldName === "lastServiceDate" && formData.purchaseDate === ""
          }
          name={el.fieldName}
          placeholder={el.title}
          value={formData[el.fieldName]}
          // errors={!!errors[el.fieldName]}
          errors={errors[el.fieldName]}
        />
      );
    }

    if (el.fieldName.endsWith("Docs")) {
      return (
        <FileField
          title={el.title}
          name={el.fieldName}
          handleChange={handleFileChange}
          errors={errors[el.fieldName] || docError[el.fieldName] || []}
          fileUrls={uploadedFiles[el.fieldName] || []}
          progress={uploadProgress[el.fieldName] || "0"}
          {...{ setUploadProgress }}
          handleDelete={handleDeleteFile}
        >
          {/* {uploadedFiles[el.fieldName]?.length > 0 && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle1">Already Uploaded Documents:</Typography>
            {renderUploadedFiles(el.fieldName)}
          </Box>
        )} */}
        </FileField>
      );
    }

    return (
      <InputField
        title={el.title}
        handleChange={handleChange}
        placeholder={el.placeholder}
        value={formData[el.fieldName] || ""}
        errors={errors[el.fieldName]}
        fieldName={el.fieldName}
      />
    );
  };

  const list = () => (
    <Box display="flex" gap={3} sx={{ width: "25.5rem" }}>
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}{" "}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={() => handleClose()} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box sx={{ width: "90%", p: 3, backgroundColor: "#fff" }}>
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {id ? "Edit Vehicle" : "Add Vehicle"}
        </Typography>
        {inputData.map((el) => {
          const shouldRender = el.condition === undefined || el.condition;
          if (
            el.fieldName === "ownership" &&
            (transportType === "Freight" ||
              formData?.transportType === "Freight")
          ) {
            return null;
          }
          if (
            el.fieldName === "vehicleCategory" &&
            (transportType === "Passenger" ||
              formData?.transportType === "Passenger")
          ) {
            return null;
          }
          if (
            el.fieldName === "loadCapacity" &&
            (transportType === "Passenger" ||
              formData?.transportType === "Passenger")
          ) {
            return null;
          }
          if (
            el.fieldName === "passengerCapacity" &&
            (transportType === "Freight" ||
              formData?.transportType === "Freight")
          ) {
            return null;
          }
          if (
            el.fieldName === "logisticsVendor" &&
            formData?.ownership === "Company owned"
          ) {
            return null;
          }
          if (el.fieldName.endsWith("Docs") && upload === "no") return null;

          if (shouldRender) {
            return <div key={el.fieldName}>{renderInputField(el)}</div>;
          }
          return null;
        })}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        // backgroundColor: "transparent",
        height: "100vh",
        minHeight: "100vh",
        overflowY: "auto",

        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100%",
          minHeight: "100%",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleClose}
    >
      {list()}
    </Drawer>
  );
}

export default AddVehicle;
